import comp from "./VideoViewer";
export default comp;
